import { render, staticRenderFns } from "./AnnualPlayerRanking2024.vue?vue&type=template&id=2d25e45f&scoped=true"
import script from "./AnnualPlayerRanking2024.vue?vue&type=script&lang=js"
export * from "./AnnualPlayerRanking2024.vue?vue&type=script&lang=js"
import style0 from "./AnnualPlayerRanking2024.vue?vue&type=style&index=0&id=2d25e45f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d25e45f",
  null
  
)

export default component.exports